"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cleanUpVideoElement(videoElement) {
  if (videoElement) {
    console.info('Cleaning up videoElement!');
    try {
      videoElement.srcObject = null;
      console.info('Clean up videoElement successful!');
    } catch (e) {
      console.info('Failed to clean up videoElement!', e);
    }
  }
}
var _default = exports["default"] = cleanUpVideoElement;